import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            averageRate: '',
            userId: '',
            name: '',
            fromDate: '',
            toDate: '',
            rates: [],
        }
    },
    methods: {
        getRates: getRates,
        getRate: getRate,
        openRate: openRate,
        changedDateFrom: changedDateFrom,
        changedDateTo: changedDateTo,
        formatDate: formatDate,
        getRateStyle: getRateStyle,
        getName: getName,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.userId = this.$route.query.id;
        this.name = this.$route.query.name;
        this.averageRate = this.$route.query.rate;
        this.getRates();
    },
}

function changedDateFrom() {

}


function changedDateTo() {

}


function getRates() {
    var _self = this;
    var calendarTimestampFrom = Date.parse(_self.fromDate);
    var calendarTimestampTo = Date.parse(_self.toDate);
    if(isNaN(calendarTimestampFrom)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    if(isNaN(calendarTimestampTo)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });

    AdminApiService.getCourierRates(calendarTimestampFrom, calendarTimestampTo)
        .then((response) => {
            _self.rates = response.data;
            swal.close();
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getRate(user){
    var courierRate = user.rate != null ? user.rate : 1;
    var list = [];
    var i = 0;
    for(i = 0; i < 5; i++){
        list.push({rate: i, selected: i < courierRate})
    }
    return list;
}

function getRateStyle(rate){
    if(rate.selected){
        return "color: #fcc201;"
    }else{
        return "color: #707070;"
    }
}

function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY - HH:mm')
}

function getName(item){
    if(item.customer != null) return item.customer.firstName + ' ' + item.customer.lastName;
    return item.companyStaff.firstName + ' ' + item.companyStaff.lastName + ' ( ' + item.companyStaff.company.name + ' ) ';
}

function openRate(user){
    var courierRate = user.averageRate != null ? round(user.averageRate) : 1;
    this.$router.push('/courier-rate?name=' + user.firstName + '&id=' + user.id + '&rate='+ courierRate);
}
function round(num){
    return Math.round((num + Number.EPSILON) * 100) / 100
}


// WEBPACK FOOTER //
// ./src/components/RateAndBugs/CourierRates.js